module.exports = __webpack_public_path__ + "static/media/adversarialHelper.f087a28e.png";